import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';

import TextAreaField from '../../form/textarea-field';
import CheckboxField from '../../form/checkbox-field';

import { scrollToTop } from '../../../utils/ui';

class CostForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {} } = props;

        this.state = {
            fields: {
                productMarketBrand: {
                    onChange: this.onChangeForm.bind(this, 'productMarketBrand'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                customerProfile: {
                    onChange: this.onChangeForm.bind(this, 'customerProfile'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },

            },
            errors: {},
            form: { ...bPitch },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeForm(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    onChangeFormCheckbox(prop, e) {

        const value = e.target.checked;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSaving() {

        clearTimeout(this.t);
        this.t = setTimeout(() => this.onSave(), 1000)
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        const bPitch = this.props.bPitch || {};

        const { isProductInfoViaUpload } = bPitch;

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Produto, Marca e Mercado")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '40rem' }}>

                    <TextAreaField
                        {...this.state.fields.productMarketBrand}
                        markAsRequired={!isProductInfoViaUpload}
                        markAsOptional={isProductInfoViaUpload}
                        label={I18n.get("Descreva o produto e/ou serviço e marca e o mercado de atuação")}
                        value={this.state.form.productMarketBrand}
                        error={this.state.errors.productMarketBrand} />

                    <br />

                    <TextAreaField
                        {...this.state.fields.customerProfile}
                        markAsRequired={!isProductInfoViaUpload}
                        markAsOptional={isProductInfoViaUpload}
                        label={I18n.get("Fale um pouco do perfil do usuário, consumidor e/ou cliente")}
                        value={this.state.form.customerProfile}
                        error={this.state.errors.customerProfile} />

                    <br />

                </div>
            </div>
        );
    }
}

export default CostForm;
